import React, { useEffect } from 'react'
import { Table } from '@imcva/reactstrap-table'
import { columns } from './columns'
import { useCardContext } from 'src/components/Card/CardContext'
import { useEeocs } from 'src/queries'
import { UseFilterStateResults } from './Filters/useFilterState'

interface CardBodyProps {
  columns: ReturnType<typeof columns>
  queryFilters: UseFilterStateResults['queryFilters']
}

const Body: React.FC<CardBodyProps> = (props) => {
  const { columns, queryFilters } = props
  const eeocs = useEeocs(queryFilters)
  const card = useCardContext()
  const count = eeocs.length
  useEffect(() => {
    card.setTitle(`EEOC Documents (${String(count)})`)
  }, [count])
  return (
    <Table storageKey='cat-eeocs' options={{ data: eeocs, columns, initialState: { sorting: [{ id: 'status', desc: false }] } }} />
  )
}

export default Body
